import { getSubmissionDetails } from "./getSubmissionDetails"
import { getSubmissionAllies } from "./getSubmissionAllies"
import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  GET_APPROVED_AND_INVESTMENT_DISTRIBUTION
} from "../../graphql/submission/queries/get-approved-and-investment-distribution"
import { getImplementerProfileCompleteness } from "./getImplementerProfileCompleteness"
import { DASHBOARD_PROJECT } from "./graphql/queries/project-dashbaords"
import { updatedBeneficiariesF21 } from "./update-beneficiaries-f21"
import { BlockBeneficiariesF21 } from "./block-beneficiaries-f21"

import { getRequestF21 } from "./get-request-f21"

const getApprovedAndInvestmentDistribution = async ({ submissionId }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_APPROVED_AND_INVESTMENT_DISTRIBUTION,
    fetchPolicy: "network-only",
    variables: {
      id: submissionId
    }
  })

  return data?.Submission
}

const getProjectToDashboard = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: DASHBOARD_PROJECT,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.DashboardProject
}

export const submissionService = () => {
  return {
    getSubmissionDetails,
    getSubmissionAllies,
    getProjectToDashboard,
    getImplementerProfileCompleteness,
    getApprovedAndInvestmentDistribution,
    updatedBeneficiariesF21,
    BlockBeneficiariesF21,
    getRequestF21
  }
}
